import App from '@app/app';
import type { LookAllowlistService } from '@app/service/season/LookAllowlistService';
import type { Job } from '@app/interface/job/job-store.interface';
import type { Package } from '@app/interface/store/package.interface';
import type { AddOn } from '@app/interface/store/add-on.interface';

class ProductService {
  constructor(private readonly lookAllowlistService: LookAllowlistService) {}

  isCustomizableProduct(orderable: Package, job: Job): boolean {
    return this.hasLookSelectionAllowedItem(orderable) && this.hasAllowedLooks(orderable, job);
  }

  private hasLookSelectionAllowedItem(orderable: Package): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return (orderable.items ?? [orderable]).some((item: AddOn) => Boolean(item.lookSelectionAllowed));
  }

  private hasAllowedLooks(orderable: Package, job: Job): boolean {
    const productSkuCode = orderable.basePackage ?? orderable.skuCode;

    /*
    TODO: Consider moving CustomizationImageService._isBgAvailable here as the single source of truth for product-specific
    look availability (premium bg lock state, whitelist/blacklist, and future rules), then reuse it in customization and `/packages`.
    The `/packages` page currently uses simpler rules and can allow navigation to a customization page with no available options.
     */
    return this.lookAllowlistService.getWhitelistByJob(productSkuCode, job)?.size !== 0;
  }
}

App.service('ProductService', ['LookAllowlistService', ProductService]);
